// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Webinars40FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Webinars40Filled: FC<Webinars40FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M35.778 34.207V7.291H4.667v13.333H1.889V7.29c0-.769.272-1.424.816-1.966a2.681 2.681 0 0 1 1.962-.812h31.11c.764 0 1.419.272 1.963.816.543.544.816 1.198.816 1.962v23.888c0 .787-.267 1.47-.8 2.05a2.982 2.982 0 0 1-1.978.978ZM15.222 22.818c-1.833 0-3.356-.606-4.57-1.82-1.212-1.212-1.819-2.735-1.819-4.569 0-1.833.607-3.356 1.82-4.57 1.213-1.212 2.736-1.818 4.57-1.818 1.832 0 3.356.606 4.569 1.819 1.212 1.213 1.819 2.736 1.819 4.57 0 1.833-.607 3.356-1.82 4.569-1.212 1.213-2.736 1.82-4.569 1.82ZM1.89 36.18v-4.166c0-1.019.257-1.91.77-2.674a5.001 5.001 0 0 1 2.008-1.743c1.814-.843 3.588-1.474 5.319-1.896a22.07 22.07 0 0 1 5.236-.632c1.76 0 3.5.215 5.222.646 1.723.43 3.49 1.06 5.304 1.887.848.401 1.528.982 2.04 1.742.511.761.767 1.651.767 2.67v4.166H1.89Z" />
        </svg>
    );
};

export default Webinars40Filled;
